import React, {
  useState,
} from 'react';

import axios from 'axios';

import {
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import './AdminLoginPage.css';

/* global process */

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const SESSION_URL =
  `${API_BASE_URL}/api/v1/admin/session`;

const CSRF_URL =
  `${API_BASE_URL}/api/v1/admin/csrf`;

const AdminLoginPage = ({
  adminUser,
  setAdminUser,
}) => {
  const navigate =
    useNavigate();

  const location =
    useLocation();

  const [email, setEmail] =
    useState('');

  const [password, setPassword] =
    useState('');

  const [submitting, setSubmitting] =
    useState(false);

  const [error, setError] =
    useState('');

  if (adminUser) {
    return (
      <Navigate
        to="/admin"
        replace
      />
    );
  }

  const handleSubmit = async (
    event
  ) => {
    event.preventDefault();

    setSubmitting(true);
    setError('');

    try {
      /*
       * 1. Authenticate with Rails / Devise.
       */
      const response =
        await axios.post(
          SESSION_URL,
          {
            email,
            password,
          },
          {
            withCredentials: true,
          }
        );

      /*
       * 2. Retrieve a CSRF token for
       * authenticated write requests.
       */
      const csrfResponse =
        await axios.get(
          CSRF_URL,
          {
            withCredentials: true,
          }
        );

      const csrfToken =
        csrfResponse.data.csrf_token;

      /*
       * 3. Keep the Devise session cookie
       * attached to subsequent API calls.
       */
      axios.defaults.withCredentials =
        true;

      /*
       * 4. Attach the CSRF token only to
       * requests that modify server data.
       */
      axios.defaults.headers.post[
        'X-CSRF-Token'
      ] = csrfToken;

      axios.defaults.headers.put[
        'X-CSRF-Token'
      ] = csrfToken;

      axios.defaults.headers.patch[
        'X-CSRF-Token'
      ] = csrfToken;

      axios.defaults.headers.delete[
        'X-CSRF-Token'
      ] = csrfToken;

      /*
       * 5. Expose the authenticated admin
       * to the React application.
       */
      setAdminUser(
        response.data.user
      );

      /*
       * 6. Return to the originally
       * requested admin page if one exists.
       */
      const destination =
        location.state?.from ||
        '/admin';

      navigate(
        destination,
        {
          replace: true,
        }
      );
    } catch (requestError) {
      console.error(
        'ACE admin sign-in error:',
        requestError
      );

      setError(
        requestError.response?.data?.error ||
        requestError.message ||
        'Unable to sign in.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="admin-login-page">
      <section className="admin-login-panel">
        <div className="admin-login-brand">
          <div className="admin-login-logo">
            ACE
          </div>

          <p>
            Actions, Culture of Excellence
          </p>
        </div>

        <div className="admin-login-content">
          <p className="admin-eyebrow">
            Administration
          </p>

          <h1>
            Sign in to ACE
          </h1>

          <p className="admin-login-intro">
            Access the secure administration
            workspace for programme content,
            opportunities, results and
            partnership enquiries.
          </p>

          {error && (
            <div className="admin-login-error">
              {error}
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            className="admin-login-form"
          >
            <label>
              Email address

              <input
                type="email"
                value={email}
                onChange={(event) =>
                  setEmail(
                    event.target.value
                  )
                }
                autoComplete="email"
                required
              />
            </label>

            <label>
              Password

              <input
                type="password"
                value={password}
                onChange={(event) =>
                  setPassword(
                    event.target.value
                  )
                }
                autoComplete="current-password"
                required
              />
            </label>

            <button
              type="submit"
              disabled={submitting}
            >
              {submitting
                ? 'Signing in...'
                : 'Sign in'}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default AdminLoginPage;
